import { useEffect, useState } from "react"
import { getBlogs } from "../../Misc/firebase";

export type Blog = {
    id: number,
    title: string,
    content: string, //it would be a html content
    date:string,
}




//Create a custome hook for load the blogfs from firestore
export function useBlogs() :  [Blog[] | undefined, boolean]{
    const [loading, setLoading] = useState<boolean>(true);
    const [blogs, setBlogs ] = useState<Blog[]>()
    useEffect(()=>{
        getBlogs()
        .then((b) => {
            setBlogs(b.reverse())
        })
        .catch(err => {
            console.log(err)
        })
        .finally(()=>{
            setLoading(false)
        })
        return ()=>{
            
        }
    },[])
    return [blogs, loading]
}